import {Directive, Input, HostListener, Component} from "@angular/core";

@Directive({
  selector: "[mouseOver]"
})
class MouseOverDirective {
  @Input() mouseOver: string = "OVERRIDE";

  private original: string;

  @HostListener("mouseover", ["$event.target"])
  onMouseOver(elm: HTMLElement) {
    this.original = elm.textContent;
    elm.textContent = this.mouseOver;
  }

  @HostListener("mouseleave", ["$event.target"])
  onMouseLeave(elm: HTMLElement) {
    elm.textContent = this.original;
  }
}

@Component({
  selector: "core-hostlistener",
  template: `
  <usecase-container title="HostListener" src="core/hostlistener">
    <usecase-content>
      <p mouseOver="Hello!">Put mouse here</p>
    </usecase-content>
  </usecase-container>
    `,
  directives: [MouseOverDirective]
})
export class HostListenerComponent {
}



/** WEBPACK FOOTER **
 ** ./script/core/hostlistener/component.ts
 **/